// obligatory I didn't write this
// https://stackoverflow.com/a/201378
// eslint-disable-next-line no-control-regex
export default /^[^\s@]+@[^\s@]+\.[^\s@]+$/;